import React from 'react'
import { Button } from '../../../../../../../../components/Button/Button'
import { AiResult } from '../../../../../../../../models/AiResult'
import { AiFeature } from '../../../../../../../../models/AiFeature'
import { useAppDispatch } from '../../../../../../../../store/hooks'

import { TrackEvent, useTracking } from '../../../../../common/tracking'
import { getAIFeatureAndResultTrackingDetails } from '../../../../../tracking'
import { useCopyData } from '../../../../hooks'
import { copyResult, HTML_TYPE, writeCopyContentToClipboard } from '../../../../copy'
import { Tooltip } from '../../../../../../../../components/Tooltip/Tooltip'
import { showToast } from '../../../../../../../../store/meetingSummary/display'
import { removeTopLevelEmptyParagraphs } from '../../../Lexical/utils'
import './HeaderResultCopyAllButton.scss'

interface ResultCopyAllButtonProps {
  aiFeature: AiFeature
  aiResult: AiResult
}

export const HeaderResultCopyAllButton: React.FC<ResultCopyAllButtonProps> = ({ aiFeature, aiResult }) => {
  const dispatch = useAppDispatch()

  const { tracked } = useTracking()

  const copyData = useCopyData()

  const _handleCopyAllClicked = async () => {
    const copiedResult = copyResult(aiFeature, aiResult, copyData)
    copiedResult[HTML_TYPE] = removeTopLevelEmptyParagraphs(copiedResult[HTML_TYPE])
    await writeCopyContentToClipboard(copiedResult)
    dispatch(showToast({ variant: 'success', icon: 'bi-check-circle-fill', message: 'Copied to clipboard!' }))
  }

  const handleCopyAllClicked = tracked(_handleCopyAllClicked, {
    eventName: TrackEvent.AI_RESULT_COPIED,
    eventDetails: {
      ...getAIFeatureAndResultTrackingDetails(aiFeature, aiResult),
    },
  })

  return (
    <Tooltip className='paragraph-small' title='Copy all' placement='top' offset={[0, 10]}>
      <Button className='px-2' variant='header' onClick={handleCopyAllClicked}>
        <i className='bi bi-copy copy-all-icon' />
      </Button>
    </Tooltip>
  )
}
